import styled from "styled-components";

export const LangContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    & > div {
        margin-top: 6px;
    }
`
export const ReturnBlock = styled.div`
    color: #929AA5;
    font-size: 10px;
    letter-spacing: 2px;
    display: flex;
    cursor: pointer;
    align-items: center;
    height: 50px;
    width: 230px;
    & > svg {
        margin: 0 10px;
        width: 10px;
        height: 10px;
        stroke: #929AA5;
    }
`
export const LangRow = styled.div<{ $isActive?: boolean }>`
    display: flex;
    height: 50px;
    width: 223px;
    border-radius: 14px;
    background: ${({ $isActive }) => $isActive ? "#23AF9105" : "#ffffff05"};
    border: 1px solid ${({ $isActive }) => $isActive ? "#23AF91" : "#ffffff10"};
    align-items: center;
    padding: 0 20px;
    font-size: 11px;
    color: ${({ $isActive }) => $isActive ? "white" : "#929AA5"};
    cursor: pointer;
    justify-content: space-between;
    & > svg {
        stroke:  ${({ $isActive }) => $isActive ? "#23AF91" : "none"};  
        fill:  ${({ $isActive }) => $isActive ? "#23AF91" : "none"};  
        width: 20px;
        height: 20px;
    }
`